import { Controller } from '@hotwired/stimulus';
import { FriendlyCaptchaSDK } from '@friendlycaptcha/sdk';

export default class extends Controller {
  static targets = ['submit', 'captcha'];
  static values = {
    sitekey: String,
    locale: String
  };

  connect() {
    // Create or reuse SDK instance (stored on the class)
    if (!this.constructor.sdk) {
      this.constructor.sdk = new FriendlyCaptchaSDK();
    }

    const widget = this.constructor.sdk.createWidget({
      apiEndpoint: 'eu',
      element: this.captchaTarget,
      sitekey: this.sitekeyValue,
      startMode: 'focus',
      // Language is optional in V2 (auto-detected), but we can still set it if needed
      ...(this.localeValue && { language: this.localeValue })
    });

    widget.addEventListener('frc:widget.complete', () => {
      this.submitTarget.disabled = false;
    });

    widget.addEventListener('frc:widget.error', (event) => {
      console.error('Friendly Captcha error'); //, event.detail.error);
    });

    widget.addEventListener('frc:widget.expire', () => {
      this.submitTarget.disabled = true;
    });

    // Store widget reference for cleanup
    this.widget = widget;
  }

  disconnect() {
    // Clean up widget if needed
    if (this.widget) {
      this.widget.destroy?.();
    }
  }
}
